require("utility/brave_checkbox.scss");

class BraveCheckbox extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			checked: props.initialValue
		};
	}

	onClick(e) {
		if (this.props.disabled) {
			return;
		}
		if (this.props.value === undefined) {
			var checked = !this.state.checked;
			this.setState({ checked: checked });			

			if (this.props.onChange) {
				this.props.onChange(checked, e);
			}

		} else {
			if (this.props.onClick) {
				this.props.onClick(e)
			}
		}
	}

	render() {
		var checked = this.props.value === undefined ? this.state.checked : this.props.value;
		if (checked) {
			var checkboxImage = (
				<img src={ require("misc/checked-checkbox.png") }
					onClick={ this.toggleStudent } className="checkedImg" />
			);

		} else {
			var checkboxImage = (
				<img src={ require("misc/unchecked-checkbox.png") }
					onClick={ this.toggleStudent } className="uncheckedImg" />
			);
		}

		var className = "braveCheckbox";
		if (this.props.className) {
			className += " " + this.props.className;
		}

		if (this.props.text) {
			className += " withLabel";
			var textLabel = (
				<span className="textLabel">
					{ this.props.text }
				</span>
			);
		}

		if (this.props.disabled) {
			className += " disabled";
		}

		return (
			<div className={ className } onClick={ this.onClick } >
				{ checkboxImage }
				{ textLabel }
			</div>
		)
	}
};

BraveCheckbox.propTypes = StrictPropTypes({
	onClick: PropTypes.func,
	onChange: PropTypes.func,
	value: PropTypes.bool,
	disabled: PropTypes.bool,
	text: PropTypes.string
});

module.exports = BraveCheckbox;



// WEBPACK FOOTER //
// ./modules/components/utility/BraveCheckbox.js